import angular from 'angular';
import controller from './student-documents-index.controller';
import template from './student-documents-index.html';

function config($stateProvider) {
    $stateProvider.state('drivecoach.student.documents.index', {
        url: '',
        controller: controller,
        controllerAs: 'vm',
        template: template
    });
}

config.$inject = ['$stateProvider'];

export default angular
    .module('student.documents.index', [])
    .config(config)
    .controller('StudentDocumentsIndexController', controller);
